export default {
	text: {
		manualBestlistsTitle: 'Kuratierte Bestenliste',
		manualBestlistTitle: 'Kuratierte Bestenliste',
		headerManualBestlistName: 'Name',
		manualBestlistsLoading: 'Bestenlisten werden geladen',
		newManualBestlist: 'Neue Bestenliste',
		updateManualBestlistTitle: 'Bestenliste ändern',
		manualBestlistCode: 'Code',
		newManualBestlistTitle: 'Neue Bestenliste',
		performancesTitle: 'Leistung',
		manualBestlistPerformanceStatusLabel: 'Status',
		manualbestlistperformancestatus: {
			official: 'Offiziell',
			inofficial: 'Inoffiziell',
		},
	},
};
